import React, { useState, useContext } from 'react'

const ActivityTypeContext = React.createContext()

export function useActivityType() {
  return useContext(ActivityTypeContext)
}

export function ActivityTypeProvider({ children }) {
  const [activityType, setActivityType] = useState('')

  return (
    <ActivityTypeContext.Provider value={{ activityType, setActivityType }}>
      {children}
    </ActivityTypeContext.Provider>
  )
}
